// LIBRARIES
import styled from "styled-components";
import { TextField } from "@mui/material";

// MISC

import { COLORS, FONTS } from "constants/styleVariables";

export const LabelContainer = styled.p`
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 7px;
`;
export const DateInputAtomContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextFieldContainer = styled(TextField)`
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.cornflowerBlue};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.cornflowerBlue};
  }
  & .MuiInputBase-root {
    background-color: ${COLORS.backgroundColor};
    padding-left: 0px;
    max-width: 150px;
    min-width: 100px;
    border-radius: 5px;
  }

  & .MuiInputBase-input {
    padding-right: 0px;
    padding-left: 10px;
  }
  & .MuiSvgIcon-root {
    @media screen and (max-width: 1850px) {
      font-size: 15px;
    }
    @media screen and (min-width: 1851px) {
      font-size: 1.5em;
    }
  }
  & .MuiButtonBase-root {
    padding-left: 0px;
    padding-right: 10px;
  }

  input::placeholder {
    @media screen and (max-width: 1850px) {
      font-size: 12px;
    }
    @media screen and (min-width: 1851px) {
      font-size: 14px;
    }
    color: ${COLORS.primaryGray};
    font-family: ${FONTS.montserrat};
    opacity: 1;
    font-weight: 600;
  }

  input {
    background: ${COLORS.backgroundColor};
    color: ${COLORS.cornflowerBlue};
    @media screen and (max-width: 1850px) {
      font-size: 12px;
      padding-top: 13px;
      padding-bottom: 12px;
    }
    @media screen and (min-width: 1851px) {
      font-size: 16px;
      padding-top: 12px;
      padding-bottom: 11px;
    }
    font-family: ${FONTS.montserrat};
    font-weight: 600;
    font-style: normal;
  }
`;
